import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const updateGeneralUser = createAsyncThunk("updateGeneralUser", async ({ id, user_channel, values }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.post(`user/update?id=${id}`, {
			...values,
			user_channel,
		});
		return response.data;
	} catch (error) {
		return rejectWithValue(error?.response?.data || { message: error.message });
	}
});

export const resetStateGeneralUserUpdateSlice = createAsyncThunk("resetStateGeneralUserUpdateSlice", async () => {
	return true;
});

const GeneralUserUpdateSlice = createSlice({
	name: "GeneralUserUpdateSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		isError: false,
	},

	extraReducers: (builder) => {
		builder.addCase(updateGeneralUser.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(updateGeneralUser.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.error = null;
			state.isError = false;
		});
		builder.addCase(updateGeneralUser.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload || action.error;
			state.isError = true;
		});

		builder.addCase(resetStateGeneralUserUpdateSlice.fulfilled, (state) => {
			state.isLoading = false;
			state.data = null;
			state.error = null;
			state.isError = false;
		});
	},
});

export default GeneralUserUpdateSlice.reducer;
